<template>
  <div class="iconPickerHeader"> 
    <div class="row ">
      <div class="col-xs-6">
        <h5>
          ICON SELECTION 
          <span v-if="category != null">| {{ category.label }}</span> 
          <el-autocomplete
            clearable
            v-if="option == 'tag_filter'"
            class="inline-input tagInput"
            v-model="tag"
            :fetch-suggestions="querySearch"
            placeholder="Please Input"
            @select="handleTagInput"
            :popper-append-to-body="false"
          ></el-autocomplete>  
        </h5>
      </div>
      <div class="col-xs-6 text-right">
        <button class="btn border mr10" v-for="(opt, index) in options" :key="index" @click="optionSelected(opt.value)">{{ opt.label }}</button>
      </div>
    </div>
    <div class="icons" >
      <icon-list class="categoryList" v-if="option == 'categories' && iconsListed.length == 0" :icons="categories" @iconSelected="categorySelected"/>
      <icon-list class="iconList" v-if="iconsListed.length > 0" :icons="iconsListed" @iconSelected="iconSelected" :sortIcons="sortIcons"/>
    </div>
  </div>
</template>
<style >
.iconPickerHeader .categoryList > ul > li{
  border: 1px solid #C5C5C5;
  width: 105px !important;
  height: auto !important;
  margin: 9px;
  padding: 4px;
}
.iconPickerHeader .categoryList > ul > li > i {
  font-size: 28px !important;
}
.iconPickerHeader .btn {
  font-size: 12px;
  background-color: white;
  border-radius: 0px;
}
.iconPickerHeader .btn:focus {
  outline: none;
}
.iconPickerHeader .btn:hover {
   background-color: #F5F7FA;
}
.iconPickerHeader h5 {
  line-height: 30px;
}
.iconList {
  margin-top:10px;
}
.tagInput {
  margin-left:10px;
}
.tagInput input {
  height: 30px;
  font-size: 13px;
}
</style>
<script>
import IconList from './IconList.vue';

export default {
  name: "IconPicker",
  components: {
    IconList
  },
  props: ['value', 'series'],
  data() {
    return {
      allIcons: [],
      option: 'categories',
      category: null,
      icon: null,
      options: [
        { label: 'CATEGORIES', value: 'categories'},
        { label: 'ALL ICONS', value: 'all_icons'},
        { label: 'TAG FILTER', value: 'tag_filter'},
      ],
      categories: [],
      tag: null,
      allTags: []
    };
  },
  computed: {
    sortIcons() {
      return typeof this.iconsListed[0].position != 'undefined' && this.option == 'categories' && this.category != null;
    },
    iconsListed() {
      var iconsFiltered = this.allIcons;
      if (this.option == 'all_icons' || this.option == 'tag_filter') {
        if (this.tag != null && this.tag != '') {
          iconsFiltered = this.filterByTag(iconsFiltered)
        }
        iconsFiltered = this.filterByIcon(iconsFiltered)
      } else if (this.option == 'categories' && this.category != null) {
        let category = this.categories.find(category => category.value == this.category.value);
        iconsFiltered = category.icons;
      } else {
        return [];
      }

      if (iconsFiltered.length > 0) {
        iconsFiltered.push({
            icon: "emptyslot"
        })
      }
      
      return iconsFiltered;
    }
  },
  methods: {
    filterByIcon(icons) { //remove duplicates
      const iconNames = icons.map(icon => icon.icon)
      const filtered = icons.filter(({icon}, index) => !iconNames.includes(icon, index + 1))
      return filtered;
      
    },
    filterBySeries(icons) { 
      return icons.filter(icon => {
        if (typeof icon.series != 'undefined') {
          return icon.series.includes(this.series);
        }
        return true;
      })
    },
    filterByTag(icons) {
      return icons.filter(icon => {
        if (typeof icon.tags != 'undefined') {
          return icon.tags.includes(this.tag);
        }
        return true;
      })
    },
    categorySelected(value) {
      this.category = value;
    },
    iconSelected(value) {
      this.$emit('input', value.icon);
    },
    optionSelected(value) {
      this.$set(this, 'option', value);
      this.category = null;
      this.tag = null;
      this.icon = null;
    },
    querySearch(queryString, cb) {
      var tags = this.allTags;
      var results = queryString ? tags.filter(this.createFilter(queryString)) : tags;
      cb(results);
    },
    createFilter(queryString) {
      return (tag) => {
        return (tag.value.indexOf(queryString.toUpperCase()) === 0);
      };
    },
    handleTagInput(item) {
      this.tag = item.value
    }
  },
  mounted() {
    try {
      var iconStore = require(`../store/${this.series}_icons.js`);
    } catch($e) {
      iconStore = require(`../store/icons.js`);
    }

    this.categories = JSON.parse(JSON.stringify(iconStore.default));
    
    this.categories = this.categories.map((category) => {
      category.icons = this.filterBySeries(category.icons);
      return category;
    })

    this.categories = this.categories.filter((category) => {
      return category.icons.length > 0;
    })
    
    this.allIcons = this.categories.reduce((allIcons, category) => { return allIcons.concat(category.icons) }, []);
    this.allTags = [...new Set([].concat(...this.allIcons.reduce((allTags, icon) => { return allTags.concat(icon.tags) }, [])))];
    this.allTags = this.allTags.map(tag => { return { value : tag }})
  }
};
</script>
